(function () {
    'use strict';

    angular.module('swif.interventions')
    .component('openstcPlanningPrintParams', {
    	templateUrl: 'partials/openstc/planning_print_params.html',
    	controller: PlanningPrintCtrl,
    	bindings: {
    		plannedTasks: '=',
    		onChange: '&'
    	}
    });

    function PlanningPrintCtrl(openstc) {
    	this.fullcalendar = openstc.planning.fullcalendar;
        this.jumpNextWeek = jumpNextWeek;
        this.jumpToPreviousWeek = jumpToPreviousWeek;
        this.backToCurrentWeek = backToCurrentWeek;
        this.options = openstc.planning.print;
        function jumpNextWeek () {
            openstc.planning.currentStart = openstc.planning.currentStart.add(1, 'weeks');
            openstc.planning.currentEnd = openstc.planning.currentEnd.add(1, 'weeks');
            this.onChange();
        }
        function backToCurrentWeek() {
            openstc.planning.currentStart = moment().startOf('isoWeek');
            openstc.planning.currentEnd = moment().endOf('isoWeek');
            this.onChange();
        }
        function jumpToPreviousWeek() {
            openstc.planning.currentStart = openstc.planning.currentStart.add(-1, 'weeks');
            openstc.planning.currentEnd = openstc.planning.currentEnd.add(-1, 'weeks');
            this.onChange();
        }
    }

})();
